import { setCurrentUserSaga } from './loginSagas';
import { logOutSaga } from './logOutSaga';

export const authSagas = [
  setCurrentUserSaga,
  logOutSaga,
];
